// extracted by mini-css-extract-plugin
export default {"viewButton":"ViewCertificateButton_viewButton__nJUG+","certIcon":"ViewCertificateButton_certIcon__fyV7u"};